import { render, staticRenderFns } from "./InkText.vue?vue&type=template&id=43b60a85&scoped=true"
import script from "./InkText.vue?vue&type=script&lang=js"
export * from "./InkText.vue?vue&type=script&lang=js"
import style0 from "./InkText.vue?vue&type=style&index=0&id=43b60a85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b60a85",
  null
  
)

export default component.exports